import { templateCodeMap } from '~/components/payment-beta/deposit/templates/constants';
import { JSONObject, StoreState } from '~/components/payment-beta/types';
import { NormalisedExecuteDepositDAO } from '~/components/payment-beta/types/deposit';
import { browserInfo } from '~/components/payment-beta/utils';
import { Templates } from '~/components/payment-beta/utils/constants';
import { encryptCCData } from '~/components/payment-beta/utils/credit-card';
import { HttpMethods, requestApi } from '~/services/api-new';

const loopKeys: string[] = [
	'accHistRef',
	'actualSendHandler',
	'appUrl',
	'availableDepositAmount',
	'errorMessage',
	'externalParameters',
	'externalUrl',
	'form',
	'methodDetails',
	'paymentFetchResultFlow',
	'qrCode',
	'redirectUrl',
	'successful'
];

const verifyAndEncryptPayload = async (meta: StoreState['meta'], formTemplateCode?: string) => {
	// The details entered in the amounts step will be handled here (ex: CVV, secureId) other payload items are handled through Spec object
	switch (formTemplateCode && templateCodeMap[formTemplateCode]) {
		case Templates.CREDIT_CARD: {
			const { selectedAccount: account, bypassCvv, cvv } = meta;
			const { id: cid, cvv: cc, cn, vm, vy } = account ?? {};

			return {
				...(await encryptCCData({ cc: cc || cvv || '', cn, vm, vy })),
				bypassCvv,
				cid,
				browserInfo
			};
		}

		default:
			return {};
	}
};

export function normalize(response: JSONObject): NormalisedExecuteDepositDAO {
	const result: Record<string, unknown> = {};

	function recurrsiveFn(currentObj: JSONObject): void {
		Object.keys(currentObj).forEach((key: string) => {
			const value = currentObj[key];

			if (loopKeys.includes(key)) {
				result[key] = value;
			} else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
				recurrsiveFn(value);
			}
		});
	}

	recurrsiveFn(response);
	return result as NormalisedExecuteDepositDAO;
}

export const paymentExecute = async (
	endpoint: string | undefined,
	payload: Record<string, unknown>,
	meta: StoreState['meta'],
	formTemplateCode?: string
) => {
	const response = await requestApi<JSONObject>({
		endpoint,
		payload: { ...payload, ...(await verifyAndEncryptPayload(meta, formTemplateCode)) },
		method: HttpMethods.POST
	});

	return normalize(response);
};
